import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row pt-3 pl-3 radio text-center",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "ml-1",
  style: {"font-size":"12px","font-weight":"500"}
}, [
  /*#__PURE__*/_createTextVNode(" He leido y acepto el "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://utel.mx/avisos-de-privacidad" }, " Aviso de privacidad ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RadioButton, {
        name: "city",
        value: true,
        modelValue: _ctx.v$.name.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event)),
        onChange: _ctx.setValues
      }, null, 8, ["modelValue", "onChange"]),
      _hoisted_2
    ])
  ]))
}